// These feature areas remain implemented in source and backed by existing data,
// but are intentionally unavailable in the simplified client dashboard.
export const SAVED_FEATURE_REDIRECTS = [
  "work/*",
  "projects/*",
  "activity",
  "requests",
  "overview",
  "outcomes/*",
  "store/*",
  "revenue/*",
  "settings",
  "settings/agent",
  "settings/automations",
  "agent",
  "automations",
];

const CONNECTION_KEY_PATTERN = /^[a-z][a-z0-9_]{1,63}$/;
// What a provider callback may say about the sign-in it just ended (the Pipedream and Meta callbacks in server/app.ts):
// `denied` is a person who cancelled at the provider, `no_ad_accounts` a Meta sign-in that reached no ad account.
const CALLBACK_STATUSES = new Set([
  "authorization_pending",
  "verification_pending",
  "ready",
  "failed",
  "error",
  "denied",
  "no_ad_accounts",
]);

export function connectionRedirectTarget(search = "") {
  const input = new URLSearchParams(search);
  const safe = new URLSearchParams();
  const appKey = input.get("connection");
  const status = input.get("status");
  if (CONNECTION_KEY_PATTERN.test(appKey || "")) safe.set("connection", appKey);
  if (CONNECTION_KEY_PATTERN.test(appKey || "") && CALLBACK_STATUSES.has(status)) safe.set("status", status);
  const query = safe.toString();
  return `/connections${query ? `?${query}` : ""}`;
}
